import { arrayOf, bool, shape, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const projectMilestoneRole = shape({
  id: string,
  roleId: string,
  regionId: string,
  functionalAreaId: string,
  limitedList: bool,
  isNotApplicable: bool,
  canSetNotApplicable: bool,
  isDeleted: bool,
  assignedUsers: arrayOf(
    shape({
      userId: string,
    })
  ),
  availableUsers: arrayOf(
    shape({
      userId: string,
      fullName: string,
    })
  ),
});
